import React, { useState } from 'react';
import Http from '../../../Http';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@material-ui/core';

const ModalActualizarPago = ({ open, onClose, pagoId, valorPrevio, onSuccess }) => {
    const [valorNuevo, setValorNuevo] = useState('');
    const [razonCambio, setRazonCambio] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSave = async () => {
        if (!valorNuevo || !razonCambio) return;
        setLoading(true);
        let Res = await Http.post(`pago-transportista-detalle/update/${pagoId}`, {
            valor_nuevo: valorNuevo,
            razon_cambio: razonCambio
        });
        setLoading(false);
        if (!Res.error) {
            onSuccess();
            onClose();
        } else {
            alert("Error al actualizar: " + Res.message);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Actualizar Valor de Pago</DialogTitle>
            <DialogContent dividers>
                <p><strong>Valor Anterior:</strong> ${Number(valorPrevio).toFixed(2)}</p>
                <TextField
                    label="Nuevo Valor"
                    type="number"
                    fullWidth
                    margin="normal"
                    value={valorNuevo}
                    onChange={(e) => setValorNuevo(e.target.value)}
                />
                <TextField
                    label="Razón del cambio"
                    multiline
                    rows={3}
                    fullWidth
                    margin="normal"
                    value={razonCambio}
                    onChange={(e) => setRazonCambio(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="default" disabled={loading}>
                    Cancelar
                </Button>
                <Button onClick={handleSave} color="primary" variant="contained" disabled={loading || !valorNuevo || !razonCambio}>
                    Guardar Cambios
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalActualizarPago;
